import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from '@praktio/common-ui';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';

import PageHeader from '../common/PageHeader/PageHeader';
import Tree from '../common/Tree/Tree';

import { RootState } from '../../ducks/store';
import { getTeams } from '../../ducks/teams';
import { buildTeamHierarchy } from '../../utils/functions';

import './Teams.scss';
import TeamName from '../common/TeamName/TeamName';

const Teams = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { teams } = useSelector((state: RootState) => {
    const teams = buildTeamHierarchy({ teams: state.teams.list || [], sorted: true });
    return {
      teams,
    };
  });

  useEffect(() => {
    dispatch(getTeams());
  }, [dispatch]);

  return (
    <Container fluid className="Teams">
      <Helmet>
        <title>Teams - Praktio</title>
      </Helmet>
      <Row className="h-100">
        <Col className={classNames('p-0 h-100 d-flex flex-column col-xs-12')}>
          <PageHeader pageName="Teams">
            <Button onClick={() => navigate(`/admin/teams/new`)}>Add</Button>
          </PageHeader>
          <div className="Teams-content">
            <Tree
              data={teams}
              searchable
              renderName={(c: ITeam) => (
                <div
                  className="Teams-row"
                  key={c._id}
                  onClick={() => {
                    navigate(`/admin/teams/${c._id}`);
                  }}
                >
                  <Link to={`/admin/teams/${c._id}`}>
                    <TeamName team={c} />
                  </Link>
                  <Button
                    className="Teams-subteam-button"
                    noStyling
                    onClick={(e) => {
                      e?.stopPropagation();
                      e?.preventDefault();
                      navigate(`/admin/teams/new?parentId=${c._id}&parentName=${c.name}`);
                    }}
                  >
                    <span className="material-icons">add</span>
                    <span>Add Subteam</span>
                  </Button>
                </div>
              )}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Teams;
